import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AppBlockingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"app_blocking"}/>
}
